import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PanSearchService {
  baseUrl: string = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getPanSearchHistory(
    page: any,
    limit: any,
    searchKey?: any,
    searchValue?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    let params = new HttpParams().set('page', page).set('size', limit);

    if (searchKey) {
      params = params.set('search_key', searchKey);
    }

    if (searchValue) {
      params = params.set('search_value', searchValue);
    }

    if (startDate) {
      params = params.set('start_date', startDate);
    }

    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(`${this.baseUrl}/pan/history`, { params });
  }

  searchPan(payload: any) {
    return this.http.post(`${this.baseUrl}/pan/search`, payload);
  }

  deletePanSearchHistory(payload: any) {
    return this.http.delete(`${this.baseUrl}/pan/delete`, {
      body: payload,
    });
  }

  getSearchResults(jobIds: string[]): Observable<any> {
    return this.http.get(`${this.baseUrl}/pan/job?job_id=${jobIds[0]}`);
  }

  getCompletedSearchResult(searchId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/pan/results/?pan_search_id=${searchId}`,
    );
  }

  exportSearchResult(searchId: string, format: string): Observable<any> {
    const params = new HttpParams()
      .set('is_export', true)
      .set('format', format);

    return this.http.get(`${this.baseUrl}/pan/results/${searchId}`, { params });
  }

  updatePanNotes(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/pan/update`, payload);
  }
}
